import $        from 'jquery';
import template from './template.hbs';
import FormStep from '../../classes/form-step';
import extend   from '../../util/extend';

export default new FormStep({
  $el: $('<form class="form-step step-address" action="canvas" />'),
  template,
  events: {
    'submit-clicked': 'track'
  },
  render( state ) {
    if ( window.preloaded_address ) {
      const address = {};

      Object.keys( window.preloaded_address ).forEach( item => {
        address[ item ] = window.preloaded_address[ item ];
      });

      if ( window.acumen ) {
        window.acumen.track( 'web-track-is_in_market', {
          in_market: !!window.in_market
        });
        window.acumen.track( 'web-track-is_d2c_eligible', {
          d2c_eligible: true
        });
      }

      state = extend( {}, state, { address } );
    }

    return FormStep.prototype.render.call( this, state );
  },
  rules: {
    first_name: /\S+/,
    last_name: /\S+/,
    email: /\S+@\S+/
  },
  track( state ) {
    if ( window.acumen ) {
      const address = Object.assign(
        {},
        window.preloaded_address,
        state.address
      );

      let addressname = null;

      if ( address.name
        && address.city
        && address.state
        && address.postal_code
      ) {
        addressname = [
          address.name,
          address.city,
          address.state,
          address.postal_code
        ].join(', ');
      }

      window.acumen.track( 'web-submit-d2c_eligible', {
        place_id: address._id || null,
        first_name: state.first_name || null,
        last_name: state.last_name || null,
        address: addressname,
        email: state.email || null
      });

      if ( state.email ) {
        window.acumen.identify({ email: state.email });
      }
    }
  }
});
